import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import URLS from 'redux/urls'
import request from 'redux/utils/request'

export const fetchAllPengguna = createAsyncThunk(
    'Pengguna/fetchAllPengguna',
    async (_, { rejectWithValue }) => {
        try {
            const response = await request('get', URLS.PENGGUNA)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)


export const fetchPenggunaByJenis = createAsyncThunk(
    'Pengguna/fetchPenggunaByJenis',
    async (jenis, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.PENGGUNA}/jenis/${jenis}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const addPengguna = createAsyncThunk(
    'Pengguna/addPengguna',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('post', URLS.PENGGUNA, payload)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const updatePengguna = createAsyncThunk(
    'Pengguna/updatePengguna',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('put', URLS.PENGGUNA, payload)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)
export const fetchOnePengguna = createAsyncThunk(
    'Pengguna/fetchOnePengguna',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.PENGGUNA}/${id}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const deletePengguna = createAsyncThunk(
    'Pengguna/deletePengguna',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('delete', `${URLS.PENGGUNA}/${id}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

const initialState = {
    loading: {
        query: false,
        mutation: false
    },
    filter: {
        q: ''
    },
    list: [],
    selected: {},
    selectedRows: []
}

const loadingReducer = (fieldName, status) => (state) => {
    state.loading[fieldName] = status
}

const startLoadingQuery = loadingReducer('query', true)
const stopLoadingQuery = loadingReducer('query', false)
const startLoadingMutation = loadingReducer('mutation', true)
const stopLoadingMutation = loadingReducer('mutation', false)

export const PenggunaSlice = createSlice({
    name: 'Pengguna',
    initialState,
    reducers: {
        setAppliedSearchText: (state, action) => {
            state.filter.q = action.payload
        },
        setSelectedRows: (state, action) => {
            state.selectedRows = action.payload
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchAllPengguna.pending, startLoadingQuery)
            .addCase(fetchAllPengguna.fulfilled, (state, action) => {
                state.list = action.payload
                state.loading.query = false
            })
            .addCase(fetchAllPengguna.rejected, stopLoadingQuery)
        builder
            .addCase(fetchOnePengguna.pending, startLoadingQuery)
            .addCase(fetchOnePengguna.rejected, stopLoadingQuery)
            .addCase(fetchOnePengguna.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(updatePengguna.pending, startLoadingQuery)
            .addCase(updatePengguna.rejected, stopLoadingQuery)
            .addCase(updatePengguna.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(fetchPenggunaByJenis.pending, startLoadingQuery)
            .addCase(fetchPenggunaByJenis.fulfilled, (state, action) => {
                state.list = action.payload
                state.loading.query = false
            })
            .addCase(fetchPenggunaByJenis.rejected, stopLoadingQuery)
        builder
            .addCase(deletePengguna.pending, startLoadingMutation)
            .addCase(deletePengguna.fulfilled, stopLoadingMutation)
            .addCase(deletePengguna.rejected, stopLoadingMutation)
    }
});


export const { setSelectedRows, setAppliedSearchText } = PenggunaSlice.actions;

export default PenggunaSlice.reducer;